import { Container, FlexContainer } from "src/design-system/Container";
import { ThemedProps } from "src/design-system/Theme/theme";
import { spacer } from "src/design-system/Tokens/tokens";
import styled from "styled-components";

export const ResponsiveViewContainer = styled(FlexContainer)`
  & > div:first-child {
    flex: 1 1 100%;
    max-width: 275px;
    margin-right: 1rem;
  }

  @media all and (max-width: 768px) {
    flex-wrap: wrap;

    & > div:first-child {
      margin: 2rem 0;
      max-width: 100%;
    }
  }
`;

export const StickyFiltersContainer = styled(Container)`
  top: 1rem;
  width: 100%;
  position: sticky;
  align-self: flex-start;
  background-color: ${(props: ThemedProps) => props.theme.menu.background};
  z-index: 1;
`;

export const FiltersWrapper = styled.div`
  padding: 12px;

  & > * {
    margin-bottom: 12px;
  }
`;

export const ResetRangeButton = styled.a`
  cursor: pointer;
  font-size: 0.825rem;
  background: transparent;
  text-decoration: underline;

  &:hover {
    text-decoration: none;
  }
`;

export const NotificationWrapper = styled(FlexContainer)`
  gap: ${spacer(1)};
`;
